import { useMount } from "@sportal/cdk/hooks";
import { useBarchartTooltip } from "./useBarchartTooltip";

export function useBarchartTooltipCleanup() {
  const unselect = useBarchartTooltip(state => state.unselect);

  useMount(() => unselect);
}
